export default () => {
  const els = document.querySelectorAll('.header__mega-menu');
  els.forEach(el => {
    el.addEventListener('mouseenter', () => {
      document.body.classList.add('mega-menu--open');
    });
    el.addEventListener('mouseleave', () => {
      document.body.classList.remove('mega-menu--open');
    });
  });
};
